<div class="container">
    <!--Checking the presence of themes-->
    <div *ngIf="themes" class="row">
        <div class="col-6">
            <div class="heading">
                <h1>Themes</h1>
                <h5>All predefined themes of an event</h5>
                <div class="d-flex mt-4">
                    <!--Filtering the items by the field (name)-->
                    <input (keyup)="filter('name', $event.target.value)" type="text" class="form-control w-50 mr-3" placeholder="Search by name">
                    <!--Filtering the items by the field (region)-->
                    <input (keyup)="filter('region', $event.target.value)" type="text" class="form-control w-50" placeholder="Search by region">
                </div>
            </div>
            <!--List of themes-->
            <theme-list [themes]="filteredThemes" (delete)="delete($event)" (edit)="edit($event)"></theme-list>
        </div>
        <div class="col-6">
            <div class="heading">
                <h1>Creator</h1>
                <h5>Create new theme</h5>
            </div>
            <!--Theme form form adding/updating a selected theme-->
            <theme-form></theme-form>
        </div>
    </div>
</div>
